let errorMap = {
  '0x80070037':'指定的网络资源或设备不再可用',
  '0xa0071001':'验证失败，请确保ukey已插入',
  '0x800704c7':'用户取消选择证书',
  '0xa0071003':'查询类型不支持',
  '0xa0071004':'Base64加密失败',
  '0xa0071005':'Base64解密失败',
  '0xa0071006':'恶意的目标路径或文件名',
  '0xa0071007':'文件为空',
  '0xa0071020':'指定证书不含有密钥用途属性',
  '0xa0071021':'指定证书不含有使用者密钥标识符属性',
  '0xa0071031':'证书链中某个证书时间无效',
  '0xa0071032':'证书在离线的CRL列表中',
  '0xa0071033':'证书链不完整',
  '0xa0071034':'证书链中某个证书签名无效',
  '0xa0071041':'aSN.1解码失败',
  '0xa0071042':'PKCS#7签名解码失败',
  '0xa0071400':'无效的私钥信息',
  '0xa0071401':'无效的私钥',
  '0xa0071402':'XML文件解析失败',
  '0xa0071403':'加密证书安装失败',
  '0xa0071404':'无效的加密证书密钥生成设备类型',
  '0xa0071405':'加密证书私钥的加密类型错误',
  '0xa0071406':'用来加密加密证书私钥的对称密钥类型错误',
  '0xa0072001':'证书没有准备好',
  '0xa0072002':'语言不支持',
  '0xa0072003':'指定主题DN的证书不唯一',
  '0xa0072004':'没有找到指定证书',
  '0xa0072020':'无效的哈希算法',
  '0xa0072021':'无效的证书用法',
  '0xa0072022':'无效的签名类型',
  '0xa0072023':'无效的数字信封类型',
  '0xa0072400':'密钥长度不支持',
  '0xa0072401':'无效的密钥算法',
}
export default errorMap


// WEBPACK FOOTER //
// ./apps/cfca/cryptokit/sendMsg/errorMap.js